module.exports = __webpack_public_path__ + "img/ic_copy.6631dbd5.svg";